export const comments_5519467 = {"data":{"data":[],"links":{}}}